import { NotificationTemplateType } from '../notification-template/notification-template-type.enum';
var EmailTemplateBuilder = /** @class */ (function () {
    function EmailTemplateBuilder() {
        this.emailTemplate = {
            type: NotificationTemplateType.ACCOUNT_OWNER_WELCOME,
            locale: 'en',
            subject: '',
            bodyHtml: '',
            placeholders: [],
            allowDisable: false,
            disabled: true
        };
    }
    EmailTemplateBuilder.prototype.withType = function (type) {
        this.emailTemplate.type = type;
        return this;
    };
    EmailTemplateBuilder.prototype.withLocale = function (locale) {
        this.emailTemplate.locale = locale;
        return this;
    };
    EmailTemplateBuilder.prototype.withSubject = function (subject) {
        this.emailTemplate.subject = subject;
        return this;
    };
    EmailTemplateBuilder.prototype.withBodyHtml = function (bodyHtml) {
        this.emailTemplate.bodyHtml = bodyHtml;
        return this;
    };
    EmailTemplateBuilder.prototype.withPlaceholders = function (placeholders) {
        this.emailTemplate.placeholders = placeholders;
        return this;
    };
    EmailTemplateBuilder.prototype.withAllowDisable = function (allowDisable) {
        this.emailTemplate.allowDisable = allowDisable;
        return this;
    };
    EmailTemplateBuilder.prototype.withIsDisabled = function (disabled) {
        this.emailTemplate.disabled = disabled;
        return this;
    };
    EmailTemplateBuilder.prototype.build = function () {
        return this.emailTemplate;
    };
    return EmailTemplateBuilder;
}());
export { EmailTemplateBuilder };
//# sourceMappingURL=email-template.builder.js.map